/**
 * Trang thông báo không có quyền.
 *
 * Nguyên tắc bắt buộc của chương 14 đặc tả giao diện: truy cập trực tiếp bằng
 * đường dẫn một màn hình ngoài quyền thì trả về TRANG NÀY, không phải trang trắng
 * và cũng không âm thầm chuyển hướng — người dùng phải biết mình thiếu quyền gì.
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { vi } from '../ngon-ngu/vi';

export function TrangKhongCoQuyen({ quyenCan }: { quyenCan?: string }): ReactNode {
  return (
    <section className="man-hinh" data-vung="khong-co-quyen" role="alert">
      <h1>{vi.khongCoQuyen.tieuDe}</h1>
      <p>{vi.khongCoQuyen.moTa}</p>
      {quyenCan ? (
        <p>
          {vi.khongCoQuyen.quyenCan}: <code>{quyenCan}</code>
        </p>
      ) : null}
      <Link className="nut" to="/tong-quan">
        {vi.khongCoQuyen.veTongQuan}
      </Link>
    </section>
  );
}
